import {IServiceFactory} from "../../service-factory.interface";
import {UserSessionStorageKeys} from "../../storage/user-session-storage/user-session-storage-keys";

export function moveBookingSessionDataOnNewToken(oldToken: string, newToken: string, services: IServiceFactory) {
    if(oldToken === newToken) {
        return;
    }

    const activeSessionToken = services.userSessionStorage.getItem(UserSessionStorageKeys.ActiveBookingToken);

    if(oldToken === activeSessionToken) {
        services.userSessionStorage.setItem(UserSessionStorageKeys.ActiveBookingToken, newToken);
    }

    const bookingSessionStorageData = services.userSessionStorage.getJson(UserSessionStorageKeys.BookingSessionStorage, {
        discriminator: oldToken
    });

    if(bookingSessionStorageData) {
        services.userSessionStorage.removeItem(UserSessionStorageKeys.BookingSessionStorage, {
            discriminator: oldToken
        });

        services.userSessionStorage.setJson(UserSessionStorageKeys.BookingSessionStorage, bookingSessionStorageData, {
            discriminator: newToken
        });
    }


}